"use client";

import { c as _c } from "react/compiler-runtime";
import { HiArrowLeft } from "react-icons/hi2";
import { Button } from "@/components/ui";
import { Sidebar } from "@/components/ui/sidebar";
import { SiteMapItem } from "@/config/sitemap";
import { cx } from "@/lib/tailwind-utils";
import { SidebarFooter } from "./sidebar-footer";
import { SidebarHeader } from "./sidebar-header";
import { SidebarNav } from "./sidebar-nav";
interface AppSidebarProps {
  /** Settings and Analytics replace the main nav and offer a way back out. */
  isSubNavMode: boolean;
  handleBack: () => void;
  backText?: string;
  menuItems: SiteMapItem[];
  currentRoute: string | undefined;
  className?: string;
  /** Only the sidebar on screen carries tour anchors, so a tour never points at the hidden copy. */
  tourAnchors?: boolean;
}
export function AppSidebar(t0) {
  const $ = _c(17);
  const {
    isSubNavMode,
    handleBack,
    backText,
    menuItems,
    currentRoute,
    className,
    tourAnchors: t1
  } = t0;
  const tourAnchors = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cx("h-full", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== tourAnchors) {
    t3 = <SidebarHeader tourAnchors={tourAnchors} />;
    $[2] = tourAnchors;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== backText || $[5] !== handleBack || $[6] !== isSubNavMode) {
    t4 = isSubNavMode && <Button onClick={handleBack} variant="ghost" className="group/return-button ml-3 mt-2 w-fit pl-1 *:!text-foreground hover:pl-2"><HiArrowLeft className="mr-2 block h-4 w-4 transition-all duration-200 ease-in-out group-hover/return-button:mr-2 group-hover/return-button:w-4 group-hover/return-button:opacity-100 md:mr-0 md:w-0 md:opacity-0" /><p className="max-w-40 truncate">{backText ?? "Back"}</p></Button>;
    $[4] = backText;
    $[5] = handleBack;
    $[6] = isSubNavMode;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== currentRoute || $[9] !== menuItems) {
    t5 = <SidebarNav menuItems={menuItems} currentRoute={currentRoute} />;
    $[8] = currentRoute;
    $[9] = menuItems;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SidebarFooter />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t7 = <Sidebar collapsible="none" className={t2}>{t3}{t4}{t5}{t6}</Sidebar>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}